import { render, staticRenderFns } from "./bill-records.vue?vue&type=template&id=0ff3ab38&scoped=true&"
import script from "./bill-records.vue?vue&type=script&lang=js&"
export * from "./bill-records.vue?vue&type=script&lang=js&"
import style0 from "./bill-records.vue?vue&type=style&index=0&id=0ff3ab38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3ab38",
  null
  
)

export default component.exports